export default {
	init() {
		this.accordions = Array.from(document.querySelectorAll(".accordion")).map(
			(accordion) => ({
				el: accordion,
				open: false,
				grow: accordion.querySelector(".accordion--grow"),
				heading: accordion.querySelector(".accordion--heading"),
				content: accordion.querySelector(".accordion--content"),
			}),
		);

		this.accordions.forEach((accordion) => {
			accordion.handleClick = () => {
				accordion.open = !accordion.open;

				if (accordion.open) {
					accordion.grow.style.height =
						accordion.content.getBoundingClientRect().height + "px";

					accordion.el.classList.add("is-open");
				} else {
					accordion.el.classList.remove("is-open");
					accordion.grow.style.height = "0px";
				}

				ScrollTrigger.refresh(true);
			};

			accordion.heading.addEventListener("click", accordion.handleClick);
		});

		this.handleResize = () => {
			this.accordions.forEach((accordion) => {
				if (accordion.open) {
					accordion.grow.style.height =
						accordion.content.getBoundingClientRect().height + "px";
				}
			});
		};

		window.addEventListener("resize", this.handleResize);
	},

	destroy() {
		if (this.accordions) {
			this.accordions.forEach((accordion) => {
				accordion.heading.removeEventListener("click", accordion.handleClick);
			});
		}

		if (this.handleResize) {
			window.removeEventListener("resize", this.handleResize);
		}

		this.accordions = null;
		this.handleResize = null;
	},
};
